import React, { Component, PropTypes } from 'react';
import { DropDownMenu, Slider, TextField } from 'material-ui';
import { GridCell, GridContainer } from 'components/Grid';
import * as Icons from 'components/Material/SvgIcons';
import PageModule from 'components/PageModule';

var loadJSONP = (function() {
  var e = 0;
  return function(a, t, n) {
    var c = '_jsonp_' + e++;
    a += a.match(/\?/) ? '&callback=' + c : '?callback=' + c;
    var l = document.createElement('script');
    (l.type = 'text/javascript'),
      (l.src = a),
      (window[c] = function(e) {
        t.call(n || window, e),
          document.getElementsByTagName('head')[0].removeChild(l),
          (l = null),
          delete window[c];
      }),
      document.getElementsByTagName('head')[0].appendChild(l);
  };
})();

const accessToken = '18360510.5b9e1e6.de870cc4d5344ffeaae178542029e98b';

export default class InstagramFeed extends PageModule {
  static readable = 'Instagram Feed';
  static icon = 'DeviceWallpaper';
  static type = 1003;
  static public = false;
  static active = true;

  state = {
    response: null,
    reference: 'coursio',
    mode: 'tag',
    maxItems: 16
  };

  onInit() {
    const reference =
        (this.props.params && this.props.params.reference) ||
        this.state.reference,
      mode = (this.props.params && this.props.params.mode) || this.state.mode,
      maxItems =
        (this.props.params && this.props.params.maxItems) ||
        this.state.maxItems;

    this.setState({ maxItems });
    this.fetch(mode, reference);
  }

  getModuleData(moduleData) {
    const reference = this.refs.reference.getValue(),
      mode = this.state.mode,
      maxItems = this.refs.maxItems.getValue();

    this.fetch(mode, reference);

    return {
      reference: reference,
      mode: mode,
      maxItems: maxItems
    };
  }

  changeMaxItems(e, v) {
    this.setState({ maxItems: v });
  }

  changeMode(e, i) {
    this.setState({ mode: i ? 'user' : 'tag' });
  }

  fetch(mode, reference) {
    let url = '';

    if (mode == 'tag') {
      const hashtag = reference || this.state.hashtag;
      url =
        'https://api.instagram.com/v1/tags/' +
        hashtag +
        '/media/recent?access_token=' +
        accessToken;

      loadJSONP(url, data => {
        this.setState({ response: data, reference: hashtag, mode });
      });
    } else if (mode == 'user') {
      const username = reference || this.state.username;

      // get user ID by his name
      url =
        'https://api.instagram.com/v1/users/search?q=' +
        username +
        '&access_token=' +
        accessToken;

      loadJSONP(url, data => {
        if (!data.data || !data.data.length) {
          return;
        }

        let userId = data.data[0].id;

        url =
          'https://api.instagram.com/v1/users/' +
          userId +
          '/media/recent?access_token=' +
          accessToken;

        loadJSONP(url, data => {
          this.setState({
            response: data,
            reference: username,
            referenceId: userId,
            mode
          });
        });
      });
    } else {
      console.error('Unknown mode');
    }
  }

  renderEditMode(content, data) {
    let menuItems = [
      { payload: 'tag', text: 'Follow tag' },
      { payload: 'user', text: 'Follow user' }
    ];

    return (
      <GridContainer fluid={true} style={{ padding: '20px' }}>
        <GridCell size={3} xSmallSize={12}>
          <div style={{ paddingTop: '20px' }}>
            Max items: {this.state.maxItems}
          </div>
        </GridCell>
        <GridCell size={9} xSmallSize={12}>
          <Slider
            name="maxItemsSlider"
            defaultValue={this.state.maxItems}
            ref="maxItems"
            min={1}
            max={16}
            step={1}
            onChange={::this.changeMaxItems}
          />
        </GridCell>
        <GridCell size={6} xSmallSize={12}>
          <DropDownMenu
            ref="mode"
            menuItems={menuItems}
            selectedIndex={this.state.mode == 'tag' ? 0 : 1}
            onChange={::this.changeMode}
          />
        </GridCell>
        <GridCell size={6} xSmallSize={12}>
          <TextField ref="reference" defaultValue={this.state.reference} />
        </GridCell>
      </GridContainer>
    );
  }

  renderDetailMode(content, data, userdata) {
    let images = [];

    const captionStyle = {
      backgroundColor: 'rgba(40, 40, 40, 0.5)',
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      height: '20px',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      color: 'white',
      font: '12px Arial',
      padding: '6px 2px 0'
    };

    if (this.state.response) {
      const max = Math.min(
        this.state.maxItems,
        this.state.response.data.length
      );

      let source = 'thumbnail',
        width = 25;

      if ([3, 6, 9].indexOf(this.state.maxItems) != -1) {
        width = 33;
        source = 'low_resolution';
      }

      if ([2, 4].indexOf(this.state.maxItems) != -1) {
        width = 50;
        source = 'standard_resolution';
      }

      if (this.state.maxItems == 1) {
        width = 100;
        source = 'standard_resolution';
      }

      for (let i = 0; i < max; i++) {
        let item = this.state.response.data[i];

        let caption = item.caption && (
          <div style={captionStyle}>{item.caption.text}</div>
        );

        images.push(
          <div
            key={i}
            style={{
              padding: 2,
              display: 'inline-block',
              boxSizing: 'border-box',
              width: width + '%'
            }}
          >
            <div style={{ position: 'relative' }}>
              <a target="_blank" href={item.link}>
                <img style={{ width: '100%' }} src={item.images[source].url} />
              </a>
              {caption}
            </div>
          </div>
        );
      }
    }

    return <div style={{ textAlign: 'center' }}>{images}</div>;
  }
}



// WEBPACK FOOTER //
// ./src/js/plugins/PageModules/InstagramFeed.js